import React from 'react';
import { useNavigate } from 'react-router-dom';

function Footer() {
    const navigate = useNavigate();

    const currentYear = new Date().getFullYear();

    const redirectToPrivacyPolicy = () => {
        navigate("/privacypolicy");
    };
    return (
        <div dir="ltr" className="w-full py-2 px-5 bg-[var(--secondary)] text-white flex items-center justify-center flex-wrap gap-1 text-center">
            <span className="text-white">
                © {currentYear}
            </span>
            <span className="primary-text font-bold">
                DODEAL
            </span>
            <span>|</span>
            <span>All Rights Reserved </span>
            <span>|</span>
            <span
                onClick={redirectToPrivacyPolicy}
            >
                Privacy Policy
            </span>
        </div>
    );
}

export default Footer;
